import React, { useEffect, useRef } from "react";
import EmojiPicker from "emoji-picker-react";

function EmojiPickerBox({ onSelect, onClose }) {
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose?.(); 
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div className="emoji-box shadow-lg" ref={pickerRef}>
      <EmojiPicker
        height={350}
        width={300}
        skinTonesDisabled={true}
        searchDisabled={false}
        previewConfig={{ showPreview: false }} 
        onEmojiClick={(e) => onSelect(e.emoji)}
      />
    </div>
  );
}

export default EmojiPickerBox;